import * as Yup from 'yup';

const drivingSchoolLeadFormValidationSchema = Yup.object({
  drivingSchoolName: Yup.string()
    .min(2, 'Name must be more than 2 characters')
    .max(100, 'Name must be less than 100 characters')
    .required('Please enter your Driving School Name'),
  mobileNumber: Yup.string()
    .min(8, 'Phone Number must be more than 8 digits')
    .max(13, 'Phone Number must be less than 13 digits')
    .required('Please enter your phone number so that we can contact you')
    .matches(/^(\+)?\d+$/, 'Please enter a valid phone number'),
});
export default drivingSchoolLeadFormValidationSchema;
